/* global HTMLElement, customElements, cancelAnimationFrame, requestAnimationFrame */

const SCROLL_DELTA = 5
const SCROLL_TOP_HEIGHT = 250

class SiteHeaderElement extends HTMLElement {
  static observedAttributes = [
    'position', 'fixed'
  ]

  constructor () {
    super()
    this.$layout = this.querySelector('.js-site-header__layout')
    this.isFixed = this.hasAttribute('fixed')

    this.didScroll = false
    this.lastScrollTop = 0

    this.scrollCallback = () => {
      this.didScroll = true
      cancelAnimationFrame(this.scrollTimeout)
      this.scrollTimeout = requestAnimationFrame(() => {
        this.update()
        this.didScroll = false
      })
    }
  }

  initEvents () {
    if (!this.isFixed) {
      return
    }

    this.ownerDocument.defaultView.addEventListener('scroll', this.scrollCallback, { passive: true })
  }

  update () {
    const st = this.ownerDocument.defaultView.scrollY
    const h = this.getBoundingClientRect().height

    if (Math.abs(this.lastScrollTop - st) <= SCROLL_DELTA) {
      if (st > this.lastScrollTop && st > h) {
        // scroll down
        this.classList.remove('is-pinned')
      } else if (st + this.ownerDocument.defaultView.innerHeight < this.ownerDocument.body.offsetHeight) {
        // scroll up
        this.classList.add('is-pinned')
      }
    }

    this.classList.toggle('is-top', st < SCROLL_TOP_HEIGHT)

    this.lastScrollTop = st
  }

  destroyEvents () {
    this.ownerDocument.defaultView.removeEventListener(
      'scroll',
      this.scrollCallback
    )
  }

  connectedCallback () {
    this.$layout.style.setProperty('transition', 'none')
    this.initEvents()
    this.update()
    setTimeout(() => {
      this.$layout.style.removeProperty('transition')
    }, 300)
  }

  disconnectedCallback () {
    this.destroyEvents()
  }

  adoptedCallback () {
    this.destroyEvents()
    this.initEvents()
  }

  attributeChangedCallback (name, oldValue, newValue) {
    if (newValue === oldValue) {
      return
    }

    this.destroyEvents()
    this.initEvents()
  }
}

customElements.define('x-site-header', SiteHeaderElement)
